<template>
  <SharedPagesWorksSlugComponent
    :pageData="data"
    :parentPageData="parentData"
    :parentRoute="{ name: 'permanent-works' }"
    routeName="permanent-works-slug"
  />
</template>

<script setup>
// 1
defineI18nRoute({
  paths: {
    en: '/permanent-works/[slug]',
    nl: '/permanente-werken/[slug]'
  }
})

// 2
const queryPath = queryPermanentWorkEntryBySlug(baseStrapiGetSlugQueryObjectFromRoute())
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.length || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)

// 3
const { data: parentData, error: parentError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPermanentWorksPageThumbnail() } }
  )
})
</script>
